export default __webpack_public_path__ + "static/Asif_Seemab-e933503fd65e4fcd6323aba8804f989f.jpg";